import api from "./propMixApi";

export function getPropMixStats() {
  return api.getStats(undefined);
}

export function retryPropMixLookup(failureId: number) {
  return api.retryLookup(failureId);
}

export function retryAllPropMixFailures() {
  return api.retryAllFailures(undefined);
}

export async function exportFailedPropMixLookups(
  batchId: string,
  userId?: string
) {
  const response = await api.exportFailedPropMixLookups(batchId, userId);
  return response.data;
}
